<script>
export default {
  name: 'centerReward',
  data() {
    return{
      // 考核期
      showAssessFlag:false,
      showAssessValue:'',
      assessList:[
        {name:'2026年1月'},
        {name:'2025年12月'},
        {name:'2025年11月'},
        {name:'2025年10月'},
        {name:'2025年9月'},
        {name:'2024年8月'}
      ],
      // 地市
      showReviewFlag:false,
      showReviewValue:'',
      areaList:[
        {name:'拉萨市'},
        {name:'日喀则市'},
        {name:'昌都市'},
        {name:'阿里地区'},
        {name:'那曲市'},
        {name:'林芝市'}
      ],
      // 片区
      areaShow:false,
      showAreaFlag:false,
      showAreaValue:'',
      areaItemList:[
        {name:'柳梧片区'},
        {name:'堆龙片区'},
        {name:'东郊片区'},
        {name:'北郊片区'},
      ],
      // 列表数据
      page1: 1,//当前页
      size1: 20,//每页条数
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      inList: [
        // {
        //   name:'张三',
        //   count:'拉萨市',
        //   area:'城关区',
        //   number:'2122',
        //   score:'34',
        //   rewardList:[
        //     {
        //       name:'业务考核奖励',
        //       number:'540',
        //       score:'5',
        //     },{
        //       name:'渠道建设奖励',
        //       number:'540',
        //       score:'5',
        //     },{
        //       name:'形象宣传奖励',
        //       number:'540',
        //       score:'5',
        //     }
        //   ]
        // },{
        //   name:'张三',
        //   count:'拉萨市',
        //   area:'城关区',
        //   number:'2122',
        //   score:'34',
        //   rewardList:[
        //     {
        //       name:'业务考核奖励',
        //       number:'540',
        //       score:'5',
        //     },{
        //       name:'渠道建设奖励',
        //       number:'540',
        //       score:'5',
        //     },{
        //       name:'形象宣传奖励',
        //       number:'540',
        //       score:'5',
        //     }
        //   ]
        // },{
        //   name:'张三',
        //   count:'拉萨市',
        //   area:'城关区',
        //   number:'2122',
        //   score:'34',
        //   rewardList:[
        //     {
        //       name:'业务考核奖励',
        //       number:'540',
        //       score:'5',
        //     },{
        //       name:'渠道建设奖励',
        //       number:'540',
        //       score:'5',
        //     },{
        //       name:'形象宣传奖励',
        //       number:'540',
        //       score:'5',
        //     }
        //   ]
        // }
      ],
    }
  },
  watch: {
    // 监控参数变化
    searchParams: function (val, oldVal) {
      if (val.state !== oldVal.state) {
        this.page1 = 1;
      }
    },
  },
  computed: {
    // 监控参数变化更新
    searchParams() {
      return {
        pageSize: this.size1,//每页数量
        pageNum: this.page1,//当前页码
        state:''
      };
    },
  },
  created() {
    // this.getListData();
  },
  methods:{
    // 地市
    onReviewType(value){
      console.log(value.name)
      this.showReviewValue = value.name;
      this.areaShow = value.name === '拉萨市';
      this.showReviewFlag = false;
    },
    // 片区
    onAreaItemType(value){
      console.log(value)
      this.showAreaValue = value.name;
      this.showAreaFlag = false;
    },
    // 考核期
    onShowAssessType(value){
      console.log(value)
      this.showAssessValue = value.name;
      this.showAssessFlag = false;
    },
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    // 当前列表数据
    getListData() {
      this.loading1 = true;
      this.finished1 = false;
      if (this.searchParams.pageNum === 1) {
        this.inList = [];
      }
      if (this.searchParams.siteid) {
        this.inList = [];
      }
      // inspectionMobilePageList(this.searchParams).then((res) => {
      //   if (res) {
      //     if (res.data) {
      //       this.loading1 = false;
      //       if (res.data.code === 200) {
      //         // this.inList = res.data.rows;
      //         this.totals1 = res.data.total;
      //         this.totalPages1 = Math.ceil(res.data.total / this.size1);
      //         if (res.data.rows == null || res.data.rows.length === 0) {
      //           this.finished1 = true;
      //           this.inList = [];
      //           return false;
      //         } else {
      //           if (this.page1 > 1) {
      //             this.inList = this.inList.concat(res.data.rows);
      //           } else {
      //             this.inList = res.data.rows;
      //           }
      //           // 总条数和每页条数
      //           if (this.totals1 < this.size1) {
      //             this.finished1 = true;
      //             return;
      //           }
      //           // 当前页和总页数
      //           if (this.page1 === this.totalPages1) {
      //             this.finished1 = true;
      //             return false;
      //           }
      //         }
      //       } else {
      //         this.$toast.fail(res.data.msg);
      //       }
      //     }
      //   }
      // });
    },
  }
}
</script>

<template>
  <div class="tech-content">
    <div class="card ">
      <div class="label-title puu20">筛选条件</div>
      <div class="stack-group pdd20">
        <div class="label-stack">
          <div class="label-stack-title">考核期<span>*</span></div>
          <div class="label-stack-text">
            <van-field
                v-model="showAssessValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择考核期"
                @click="showAssessFlag=true"
            >
              <template #right-icon>
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
          </div>
        </div>
        <div class="label-stack">
        <div class="label-stack-title">地市<span>*</span></div>
        <div class="label-stack-text">
          <van-field
              v-model="showReviewValue"
              name=""
              label=""
              readonly="readonly"
              placeholder="请选择地市"
              @click="showReviewFlag=true"
          >
            <template #right-icon>
              <van-icon name="arrow-down"/>
            </template>
          </van-field>
        </div>
      </div>
      </div>
      <div class="stack-group pdd20">
        <div class="label-stack" v-if="areaShow">
          <div class="label-stack-title">片区<span>*</span></div>
          <div class="label-stack-text">
            <van-field
                v-model="showAreaValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择片区"
                @click="showAreaFlag=true"
            >
              <template #right-icon>
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div class="label-button pdd20 puu20">
        <div class="label-query">查询</div>
        <div class="label-cancel">重置</div>
      </div>
    </div>
    <div class="stats-card">
      <div>奖励统计</div>
      <div class="stats-grid">
        <div class="stat-item">
          <div class="state-value ">0</div>
          <div class="stat-label">获奖人数</div>
        </div>
        <div class="stat-item">
          <div class="state-value ">0</div>
          <div class="stat-label">总积分</div>
        </div>
        <div class="stat-item">
          <div class="state-value ">¥0</div>
          <div class="stat-label">总金额</div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="label-title puu20">
        奖励明细{{inList.length}}
      </div>
      <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false"
                @load="onLoad">
        <div class="reward-item" v-for="(item,index) in inList" :key="index" v-if="inList.length>0">
          <div class="reward-header pdd20">
            <div class="supervisor-info">
              <div class="supervisor-avatar">{{item.name.substring(0,1)}}</div>
              <div class="supervisor-details">
                <div class="supervisor-name">{{item.name}}</div>
                <div class="supervisor-region">{{item.count}} · {{item.area}}</div>
              </div>
            </div>
            <div class="total-amount">
              <div class="amount-value">¥{{item.number}}</div>
              <div class="amount-label">{{item.score}}分</div>
            </div>
          </div>
          <div class="in-list pdd20">
            <div class="clone-list" v-for="(v,k) in item.rewardList" :key="k">
              <div class="clone-name"><span class="icon-grant"></span>{{v.name}}</div>
              <div class="clone-row">
                <div class="it-row">
                  <div class="it-row-up">+{{item.score}}</div>
                  <div class="it-row-do">分</div>
                </div>
                <div class="it-row">
                  <div class="it-row-up">¥{{item.number}}</div>
                  <div class="it-row-do">元</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="inList.length===0">
          <div class="empty-state">
            <div class="empty-icon"><i class="fas fa-inbox"></i></div>
            <div class="empty-text">暂无奖励记录</div>
            <div class="empty-hint">请调整筛选条件后重试</div>
          </div>
        </div>
      </van-list>
    </div>
    <!--  地市  -->
    <van-popup v-model="showReviewFlag" position="bottom">
      <van-picker
          show-toolbar
          title="地市"
          :columns="areaList"
          value-key="name"
          :default-index="0"
          @confirm="onReviewType"
          @cancel="showReviewFlag = false"
      />
    </van-popup>
    <!--  片区  -->
    <van-popup v-model="showAreaFlag" position="bottom">
      <van-picker
          show-toolbar
          title="片区"
          :columns="areaItemList"
          value-key="name"
          :default-index="0"
          @confirm="onAreaItemType"
          @cancel="showAreaFlag = false"
      />
    </van-popup>
    <!--  考核期  -->
    <van-popup v-model="showAssessFlag" position="bottom">
      <van-picker
          show-toolbar
          title="考核期"
          :columns="assessList"
          value-key="name"
          :default-index="0"
          @confirm="onShowAssessType"
          @cancel="showAssessFlag = false"
      />
    </van-popup>
  </div>
</template>

<style scoped lang="scss">

.tech-content{
  font-size: 28px;
  padding-top: 120px;
  box-sizing: border-box;
  /deep/.van-cell{
    padding: 10px;
  }
  .puu20{
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .pdd20{
    padding-left: 20px;
    padding-right: 20px;
  }
  .card{
    padding: 0;
  }
  /* 空状态 */
  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: var(--text-light);
  }

  .empty-icon {
    font-size: 60px;
    color: #ddd;
    margin-bottom: 15px;
  }

  .empty-text {
    margin-bottom: 5px;
  }

  .empty-hint {
    color: #999;
  }

  .stats-card {
    background: linear-gradient(135deg, var(--primary-color), #ff5c5c);
    border-radius: 10px;
    padding: 30px 30px;
    margin-bottom: 20px;
    color: white;
    .stats-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px;
      margin-top: 10px;
    }

    .stat-item {
      text-align: center;
    }

    .state-value  {
      font-size: 35px;
      font-weight: bold;
      margin-bottom: 5px;
    }

    .stat-label {
      color: #fff;
      opacity: 0.9;
    }
  }
  .reward-item {
    padding: 15px 0;
    border-bottom: 2px solid #f0f0f0;
    transition: background 0.2s;
    .reward-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .supervisor-info {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .supervisor-avatar {
      width: 85px;
      height: 85px;
      border-radius: 50%;
      background: linear-gradient(135deg, var(--primary-color), #ff5c5c);
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: bold;
    }

    .supervisor-details {
      flex: 1;
    }

    .supervisor-name {
      font-weight: bold;
      font-size: 32px;
      color: var(--text-dark);
      margin-bottom: 3px;
    }

    .supervisor-region {
      font-size: 24px;
      color: var(--text-light);
    }

    .total-amount {
      text-align: right;
    }

    .amount-value {
      font-size: 32px;
      font-weight: bold;
      color: var(--primary-color);
      margin-bottom: 2px;
    }

    .amount-label {
      font-size: 24px;
      color: var(--text-light);
    }

    .reward-details {
      background: #f9f9f9;
      border-radius: var(--border-radius-sm);
      padding: 12px;
    }
    .in-list{
      padding-top: 20px;
    }
    .clone-list{
      display: flex;
      flex-direction: row;
      background: #f9f9f9;
      width: 100%;
      padding:10px 20px;
      border-bottom: 2px solid #ddd;
      &:last-child{
        border-bottom: none;
      }
      .clone-name{
        display: flex;
        flex: 1;
        align-items: center;
        .icon-grant{
          display: flex;
          height: 50px;
          width: 50px;
          background: rgba(76, 175, 80, 0.1);
          color: var(--success-color);
          border-radius: 50px;
          margin-right: 20px;
        }
      }
      .clone-row{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        flex: 1;
        .it-row{
          display: flex;
          flex-direction: column;
          padding-left: 30px;
          .it-row-up{
            text-align: left;
            color: #4caf50;
            font-weight: bold;
          }
          .it-row-do{
            text-align: right;
            color: #666;
            font-size: 24px;
          }
        }
      }
    }
  }

  .reward-item:last-child {
    border-bottom: none;
  }

  .reward-item:active {
    background: #f9f9f9;
  }
  .label-title{
    font-weight: bold;
    color: var(--primary-color);
    margin-bottom: 15px;
    //padding-bottom: 8px;
    //padding-left: 8px;
    margin-left: 20px;
    margin-right: 20px;
    border-bottom: 2px solid var(--primary-color);
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .stack-group{
    display: flex;
    flex-direction: row;
    gap: 18px;
  }
  .rate-gr-title{
    font-weight: bold;
    padding-bottom: 20px;
    span{
      color: red;
    }
  }
  .rate-group{
    display: flex;
    align-items: center;
    span{
      display: inline-block;
      margin-left: 20px;
    }
  }
  .label-group{
    padding-top: 20px;
    .form-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      background: transparent;
    }
    .form-group{
      background: transparent;
      padding:0;
      margin: 0;
      .t-bound{
        margin-bottom: 20px;
        .grant{
          color: transparent;
        }
        .t-bound-e{
          font-weight: bold;
          padding: 0 0 10px;
        }
        .t-bound-t{
          display: flex;
          flex-direction: row;
          align-items: center;
          /deep/.van-cell{
            width: 80%;
            background: #f9f9f9;
            border-radius: 10px;
            margin-right: 20px;
            border: 1px solid rgba(0,0,0,0.1);
          }
        }
      }
    }
  }
  .label-radio{
    padding-top: 20px;
  }
  .label-stack{
    flex: 1;
    .label-stack-title{
      padding: 10px 0;
      span{
        display: inline-block;
        color: red;
        margin-left: 10px;
      }
    }
    .label-stack-text{
      border: 2px solid #ddd;
      border-radius: 10px;
      /deep/.van-cell{
        border-radius: 10px;
      }
    }
  }
  .label-button{
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-top: 20px;
    gap: 20px;
    .label-query{
      display: flex;
      flex: 1;
      background: var(--primary-color);
      color: #fff;
      padding: 15px;
      justify-content: center;
      border-radius: 10px;
    }
    .label-cancel{
      display: flex;
      flex: 1;
      background: #f0f0f0;
      padding: 15px;
      justify-content: center;
      border-radius: 10px;
    }
    .label-commit{
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background:linear-gradient(135deg, var(--primary-color), var(--primary-dark));
    }
    .label-bound{
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background: linear-gradient(135deg, #4CAF50, #45a049);
    }
  }

}
/deep/.van-popup{
  background: transparent;
}
.inner-diag {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  .title-had{
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 40px 20px 0;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    .fixed-close {
      position: absolute;
      right: 50px;
      top: 19px;
      font-size: 50px;
      color: #999;
    }
    .section-title{
      font-size: 32px;
      background: #fff;
      padding-left: 10px;
    }
  }
  .form-buttons{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid #e5e7eb;
    padding:20px 20px;
    background: #fff;
    margin: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    span{
      display:flex;
      justify-content: center;
      flex: 1;
      border: 1px solid #e5e7eb;;
      padding: 20px 35px;
      border-radius: 10px;
    }
    .erase{
      background: #f3f4f6;
      color: #666;
    }
    .leg{
      background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
      color: white;
    }
  }
  .tabs-group{
    padding: 40px 30px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;
    .t-bound{
      margin-bottom: 20px;
      .t-bound-e{
        font-weight: bold;
        padding: 0 0 10px;
      }
      .t-bound-t{
        display: flex;
        flex-direction: row;
        align-items: center;
        /deep/.van-cell{
          width: 90%;
          background: #f9f9f9;
          border-radius: 10px;
          margin-right: 10px;
          border: 1px solid rgba(0,0,0,0.1);
        }
      }
    }
    span{
      color: #333;
      display: inline-block;
    }
    .con-app{
      color: red;
    }
    .pub{
      background: #f9fafb;
      padding:30px 15px;
      border-radius: 12px;
      margin-bottom: 20px;
    }
  }
}
</style>